const DEFAULT_MINOR_UNITS = 2;

export const getCurrencyMinorUnits = (currency: string): number => {
  try {
    return (
      new Intl.NumberFormat('en', { style: 'currency', currency }).resolvedOptions()
        .maximumFractionDigits ?? DEFAULT_MINOR_UNITS
    );
  } catch {
    return DEFAULT_MINOR_UNITS;
  }
};
